import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ppk-studio-help-dialog',
  templateUrl: './ppk-studio-help-dialog.component.html',
  styleUrls: ['./ppk-studio-help-dialog.component.scss']
})
export class PpkStudioHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<PpkStudioHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


